module.exports = __webpack_public_path__ + "img/beer_thumbnail.3742b5bb.jpg";